module.exports = __webpack_public_path__ + "gradle.png";